const routes =[
  {
    path: '/standardProduct/productVersion/index',
    name: 'productVersion',
    meta: {
      title: '订购服务',
    },
    component: () => import('@/views/standardProduct/productVersion/index'),
  },
  {
    path: '/standardProduct/order/index',
    name: 'standardProductOrder',
    meta: {
      checkLogin: true,
      title: '购买服务',
    },
    component: () => import('@/views/standardProduct/order/index'),
  },
  {
    path: '/standardProduct/exchange/index',
    name: 'exchange',
    meta: {
      checkLogin: true,
      title: '兑换',
    },
    component: () => import('@/views/standardProduct/exchange/index'),
  },
  {
    path: '/standardProduct/exchange/activateResult',
    name: 'activateResult',
    meta: {
      title: '激活结果',
    },
    component: () => import('@/views/standardProduct/exchange/activateResult'),
  },
];
export default [
  {
    path: '/main/Layout',
    component: () => import('@/views/main/Layout.vue'),
    children: [
      ...routes,
    ],
  },
];

